import localeFr from "../assets/locales/fr.json";
import localeEn from "../assets/locales/en.json";

const locales = { fr: localeFr, en: localeEn };
const availableLanguages = Object.keys(locales);

const localize = (quote, language) => {
  try {
    return locales[language][quote];
  } catch (error) {
    return quote + " not found in " + language + " locale";
  }
};

export { localize, availableLanguages };
